import React, { useEffect, useContext } from 'react';
import { ContentDiv, IntroDiv } from '../styles/MainContent'
import { ReactComponent as DownArrow } from '../../assets/icons/downArrow.svg'
import { ScrollContext } from '../context/ScrollContext';
import ChartSummary from '../components/ChartSummary/ChartSummary';
import mainContentData from '../../assets/data/mainContent';


function DataVisualisations(props) {
  const { vHeight, scrollPos, setvHeight, setScrollPos } = useContext(ScrollContext)

  useEffect(() => {
    setvHeight(window.innerHeight)
    setScrollPos(window.scrollY)
  }, [setScrollPos, setvHeight])

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setScrollPos(window.scrollY)
    })
  })

  const dynamicScale =  .9 + ((scrollPos/(vHeight * 0.9)) * .1)
  return (
    <>
      { scrollPos > -1 &&
        <>
          
          <IntroDiv>
            <div/>
            <div/>
            <div>
              Data Visualizations
            </div>
            <div>
              <DownArrow className="icon"/>
            </div>
            <div/>
          </IntroDiv>
          <ContentDiv
            scale={dynamicScale < 1 ? dynamicScale :  1}
          >
              {
                mainContentData.map((content, i) => (
                  <ChartSummary key={i} {...content} />
                ))
              }
          </ContentDiv>
        </>
      }
    </>
  );
}

export default DataVisualisations;
